import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { CustomerDto } from './customers-dto';

export const CustomerACcountTypes = [
    {name : 'Agent',value:'AGENT'},{name:'AZ',value:'AZ'},{name : 'Importer',value:'IMPORTER'},{name : 'Key Customer',value:'KEY_CUSTOMER'}
]
  

